module.exports = __webpack_public_path__ + "static/media/susan-fletcher.ada6deae.jpeg";